import React, { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    emailjs
      .send("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", formData, "YOUR_PUBLIC_KEY")
      .then(
        () => {
          alert("✅ Email berhasil dikirim!");
          setFormData({ name: "", email: "", subject: "", message: "" });
        },
        (error) => {
          alert("❌ Gagal mengirim email, coba lagi.");
          console.error(error.text);
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <footer id="contact" className="bg-background text-primary pt-24 pb-12 px-6 md:px-20 border-t border-white/5 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-accent/5 via-background to-background pointer-events-none" />

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 relative z-10">
        {/* Left - Info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-col justify-between"
        >
          <div>
            <h2 className="text-sm font-semibold tracking-widest text-muted uppercase mb-2">05. Contact</h2>
            <div className="w-12 h-1 bg-accent/50 rounded-full mb-8"></div>
            <h3 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight">
              Let's build something <span className="text-accent font-medium">together</span>.
            </h3>

            <p className="text-muted/90 mb-2 text-lg">
              Say hello at{" "}
              <a
                href="mailto:mrizkynurr@gmail.com"
                className="text-primary hover:text-accent underline decoration-white/20 underline-offset-4 hover:decoration-accent/50 transition-colors"
              >
                mrizkynurr@gmail.com
              </a>
            </p>

            <p className="text-muted/90 mb-10 text-lg">
              For more info, here's my{" "}
              <a
                href="https://drive.google.com/uc?export=download&id=1G_7CwBhvZvfyjVVGqyVuNaXwWTTVY8GD"
                download
                className="text-primary hover:text-accent underline decoration-white/20 underline-offset-4 hover:decoration-accent/50 transition-colors"
              >
                resume
              </a>
            </p>

            <div className="flex space-x-6 text-xl text-muted">
              {[
                { icon: FaLinkedin, url: "https://www.linkedin.com/in/muhamad-rizky-nurrohmat-b571922b8/?originalSubdomain=id" },
                { icon: FaGithub, url: "https://github.com/mrizkyn" },
                { icon: FaInstagram, url: "https://instagram.com/mrizkyyn" },
              ].map(({ icon: Icon, url }, index) => (
                <a
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="p-3 rounded-full bg-surface/50 border border-white/5 hover:bg-surface hover:text-accent hover:border-white/10 transition-all duration-300"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Right - Form */}
        <motion.form
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          onSubmit={handleSubmit}
          className="space-y-5"
        >
          {[
            { name: "name", label: "Name", type: "text", required: true },
            { name: "email", label: "Email", type: "email", required: true },
            { name: "subject", label: "Subject", type: "text", required: false },
          ].map((field) => (
            <div key={field.name}>
              <label className="block text-sm font-medium text-muted mb-2 ml-1">
                {field.label}
              </label>
              <input
                type={field.type}
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
                className="w-full px-5 py-3.5 rounded-xl bg-surface/30 border border-white/10 text-primary placeholder:text-muted/50 focus:outline-none focus:ring-1 focus:ring-accent focus:border-accent transition-all duration-300 backdrop-blur-sm"
              />
            </div>
          ))}

          <div>
            <label className="block text-sm font-medium text-muted mb-2 ml-1">
              Message
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
              className="w-full px-5 py-3.5 rounded-xl bg-surface/30 border border-white/10 text-primary placeholder:text-muted/50 focus:outline-none focus:ring-1 focus:ring-accent focus:border-accent transition-all duration-300 backdrop-blur-sm resize-none"
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full md:w-auto px-8 py-4 bg-primary text-black font-medium rounded-xl hover:bg-white/90 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed mt-2"
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>
        </motion.form>
      </div>

      <div className="max-w-6xl mx-auto mt-24 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-muted/60 text-sm">
          © {new Date().getFullYear()} Muhamad Rizky Nurrohmat.
        </p>
        <p className="text-muted/60 text-sm">
          Designed with simplicity in mind.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
